export default [
    {
        "id": "register-no-address",
        "html": require('./register-no-address/html').default
    }
]